// import media files
import Chrome from 'assets/images/browser-svg/chrome.svg';
import Firefox from 'assets/images/browser-svg/firefox.svg';
import Brave from 'assets/images/browser-svg/brave.svg';
import Safari from 'assets/images/browser-svg/safari.svg';
import IE from 'assets/images/browser-svg/ie.svg';
import Opera from 'assets/images/browser-svg/opera.svg';

const BrowsersStatistics = [
	{
		id: 1,
		browser: 'Google Chrome',
		logo: Chrome,
		percent: 21.54
	},
	{
		id: 2,
		browser: 'Mozilla Firefox',
		logo: Firefox,
		percent: 14.43
	},
	{
		id: 3,
		browser: 'Brave',
		logo: Brave,
		percent: 14.43
	},
	{
		id: 4,
		browser: 'Apple Safari',
		logo: Safari,
		percent: 8.54
	},
	{
		id: 5,
		browser: 'Internet Export',
		logo: IE,
		percent: 6.21
	},
	{
		id: 6,
		browser: 'Opera Mini',
		logo: Opera,
		percent: 8
	}
];

export default BrowsersStatistics;
